import React from 'react'
import SvgIcon from '@mui/material/SvgIcon';
export default function DotBlackIcon () {
    return (
    <SvgIcon>
<svg width="1" height="1" viewBox="0 -2 1 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="1" cy="1" r="0.5" fill="#475367" fillOpacity="1"/>
</svg></SvgIcon>)}